<template>
  <div class="card">
    <t-loader :loading="!loaded"></t-loader>
    <div v-if="!locked" class="card-header">
      <div>Provide Identification</div>
      <p class="mt-2 mb-0 small text-info">Before you can start using Charge you need to identify yourself.</p>
    </div>
    <div v-if="verified" class="card-header">
      User Identification
      <br>
      <small>Values used to verify your identity.</small>
    </div>
    <div class="card-body">
      <div v-if="verified" class="d-flex h-100 flex-column justify-content-between">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th>Nationality</th>
            <td>{{ nationality }}</td>
          </tr>
          <tr>
            <th>Personal Identity Number</th>
            <td>{{ values.personalNumber }}</td>
          </tr>
          </tbody>
        </table>
        <div v-if="resettable" class="text-center">
          <a href="#" @click="reset" class="almost-hidden">Accidentally connected with the wrong ID?</a>
        </div>
      </div>
      <form method="post" action="/eid/kyc/store" v-if="!verified" :disabled="locked">
        <fieldset :disabled="locked">
          <input type="hidden" name="_token" :value="csrf">
          <input type="hidden" name="provider" :value="provider">
          <div class="form-group mb-3">
            <label for="nationality" class="mb-1">Nationality</label>
            <select name="nationality" id="nationality" class="form-control" v-model="nationality" required>
              <option value="none" selected disabled>Select Country of Citizenship</option>
              <option v-for="(info, code) in countries" :value="code">{{ info.name || code }}</option>
            </select>
          </div>
          <div v-if="provider === 'seBankID'">
            <div class="form-group mt-3">
              <label for="swedishPersonalNumber" class="mb-1">Personal Identity Number</label>
              <input name="personalNumber" id="swedishPersonalNumber" v-model="values.personalNumber" class="form-control"
                     placeholder="YYYYMMDDXXXX"
                     pattern="^\d{12}$" minlength="12" maxlength="12" required>
            </div>
            <div class="form-group mt-4 mb-0" v-if="!verified">
              <button class="btn btn-primary btn-block bankId" type="submit">
                <p>
                  <img src="img/bankid-icon-color.png">
                  <span>Verify with BankID</span>
                </p>
              </button>
            </div>
          </div>
          <div v-else-if="provider === 'dkNemID'">
            <div class="form-group mt-3">
              <label for="danishPersonalNumber" class="mb-1">Personal Identity Number</label>
              <input name="personalNumber" id="danishPersonalNumber" v-model="values.personalNumber" class="form-control"
                     placeholder="YYMMDDXXXX"
                     pattern="^\d{10}$" minlength="10" maxlength="10" required>
            </div>
             <div class="form-group mt-4 mb-0" v-if="!verified">
               <button type="submit" class="btn btn-primary authSubmit btn-block w-100 text-dark bankId">
                 <img height="12"
                      src="img/dknemid-icon-black.png"
                      class="mr-3">
                 <span>Verify with NemId</span>
               </button>
            </div>
          </div>
            <div v-else-if="provider === 'noBankID'">
<!--                <div class="form-group mt-3">-->
<!--                    <label for="norwegianPersonalNumber" class="mb-1">Personal Identity Number</label>-->
<!--                    <input name="personalNumber" id="norwegianPersonalNumber" v-model="values.personalNumber" class="form-control"-->
<!--                           placeholder="DDMMYYXXXXX"-->
<!--                           pattern="^\d{11}$" minlength="11" maxlength="11" required>-->
<!--                </div>-->
                <div class="form-group mt-4 mb-0" v-if="!verified">
                    <button class="btn btn-primary btn-block" style="background: #4a78b1;" type="submit">
                        <img src="img/bankid_main_logo_white.svg" class="mr-3" height="12">
                        <span>Verify with BankID</span>
                    </button>
                </div>
            </div>
            <div v-else-if="provider === 'fiTupas'">
                <div class="form-group mt-3">
                    <label for="finnishPersonalNumber" class="mb-1">Personal Identity Number</label>
                    <input name="personalNumber" id="finnishPersonalNumber" v-model="values.personalNumber" class="form-control"
                           placeholder="DDMMYYCZZZQ"
                           pattern="^[0-9]{6}[+Aa-][0-9]{3}[A-z0-9]$" minlength="11" maxlength="11" required>
                </div>
                <div class="form-group mt-4 mb-0" v-if="!verified">
                    <button class="btn btn-primary btn-block bankId" style="" type="submit">
                        <img src="img/ftn-logo.svg" class="mr-3" height="50" style="margin:-9px">
                        <span>Verify with FTN</span>
                    </button>
                </div>
            </div>
        </fieldset>
      </form>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-center">
        Powered by
        <a class="brand ml-1" href="https://www.scrive.com/" target="_blank">
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 998 254"
               style="width: 4.5rem; enable-background:new 0 0 998 254;" xml:space="preserve"> <g id="logo-dark"> <path
              id="Logo-White" style="fill: white;"
              d="M144.8,143c7.4,1.1,13.1,2.5,17.2,4.3c4,1.8,6.6,4,8,6.7c1.6,2.9,2.4,6.2,2.3,9.6 c-0.2,4.9-1.6,9.8-4.2,13.1c-2.8,3.4-6.3,6.1-10.3,7.8c-10.3,4.6-24.4,5.9-35.5,6c-10-0.1-18.3-1.1-24.9-3.2 c-6.7-2-12.1-4.6-16-7.9c-3.6-2.9-6.5-6.6-8.4-10.7c-1.6-3.8-2.9-7.8-2.9-11.6H39c0.8,9.6,2.9,17.9,6.5,24.7 c3.3,6.5,8,12.2,13.8,16.7c5.8,4.4,12.2,7.8,19.1,10.2c7.1,2.5,14.5,4.2,21.9,5.1c7.6,1,15.2,1.4,22.9,1.4 c24.2,0,55.4-4.7,71.1-25.3c6.1-8,9.4-18.5,9.4-29.7c0.1-5.9-1.1-11.8-3.6-17.2c-2.4-4.9-5.7-9.4-9.8-13.1c-4.2-3.8-9-6.8-14.2-8.9 c-5.4-2.3-11.2-3.9-17-4.6c-18.7-2.5-60.5-6.3-72.4-11.7c-4-1.8-6.7-4.1-8.1-6.7c-1.6-2.9-2.3-6.2-2.1-9.5 c-0.1-4.4,1.2-8.7,3.8-12.2c2.8-3.3,6.2-6,10.2-7.8c4.5-1.9,9.2-3.3,14.1-4.1c5-0.8,10.1-1.2,15.2-1.2c10.9,0.1,19.8,1.5,27.1,4.3 c7.2,2.8,12.5,6.6,16.3,11.1c3.6,4.4,5.7,9.9,5.9,15.6h31c-0.6-8.1-2.3-15.7-5.6-22.4c-3.6-6.9-8.7-12.9-14.9-17.6 c-6.6-5-14.7-8.8-24.4-11.5c-9.8-2.8-21.4-4.1-35-4.2c-15.4,0.1-28.7,2.2-40,6.4s-20,10.1-26,18c-6.1,8-9.2,17.6-9.2,28.7 c-0.1,11.6,4.8,22.7,13.5,30.4c4.2,3.8,9,6.8,14.2,8.9c5.4,2.3,11,3.8,16.8,4.6C108.1,138,126.5,140.5,144.8,143z M507,215V44h28 v171H507z M959,195.3c0,10.8-8.7,19.6-19.6,19.6c-10.8,0-20.4-9.1-20.4-20c0.2-11,9-19.8,20-20C949.8,175,959,184.5,959,195.3z M353,153c-9.6,21.6-30.2,34.4-53.7,34.4c-32.7,0-59.2-27.4-59.2-61s26.5-60.7,59.2-60.7c23.4,0,44.1,15.6,53.7,35.2h28 c-10.9-35.3-43.2-62.8-81.7-62.8c-47.4,0-85.9,39.4-85.9,88.2s38.4,88.6,85.9,88.6c38.4,0,70.7-26.6,81.7-62L353,153L353,153z M913,138c0.5-3.6,0.9-7.3,1-11c0-48.8-38.8-89-86.2-89S742,77.4,742,126.2s38.4,88.8,85.8,88.8c38.4,0,71.2-26.6,82.2-62h-29 c-9.6,19.6-29.7,35-53.2,35c-29.1,0-52.9-22.5-57.8-50H913z M827.8,66.3c26.7,0,50.1,17.9,57.2,43.7H771 C778.1,84.5,800.8,66.3,827.8,66.3z M743.3,44.2L744,44h-29h-0.8l-46,123.3l-26-67.6l-0.1-0.1C627.8,65.3,594.2,43,557,43v28 c29.3,0.1,54.1,19,62.2,45.2l0.1,0.3l37.8,98.5h22.8l63.7-170.8L743.3,44.2L743.3,44.2z M487,44c-0.9,0-2.1,0-3,0 c-47.6,0-86.1,40.4-87.9,90.6H396V215h28v-77l0,0c0.1-35.7,26.5-64,60-64c0.9,0,2.1,0,3,0V44z"></path> </g> </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'KnowYourCustomer',
  data() {
    return {
      nationality: 'none',
      countries: [],
      loaded: false,
      verified: false,
      resettable: false,
      values: {},
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    };
  },
  computed: {
    provider: function() {
      if (this.nationality !== 'none' && this.countries.hasOwnProperty(this.nationality)) {
        return this.countries[this.nationality].provider || null;
      }

      return null;
    },
    locked() {
      return this.verified;
    },
  },
  methods: {
    resetValues() {
      this.values = {
        personalNumber: null,
      };
    },
    reset() {
      Swal.fire({
        icon: 'warning',
        title: 'Reset Identification',
        text: `If you've accidentally connected with the wrong ID, you can remove the current identification from this user allowing you to connect to a new identity.`,
        showCancelButton: true,
        confirmButtonColor: '#007bff',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        axios.post('/eid/kyc/reset').then((response) => {
          const data = response.data || {};
          Swal.fire({
            icon: 'success',
            text: 'Removed the identification from your user.',
          });
        }).catch((response) => {
          const data = response.data || {};
          Swal.fire({
            icon: 'error',
            text: data.message || 'Something went wrong, please try again later.',
          });
        }).finally(() => {
          this.refresh();
        });
      });
    },
    refresh() {
      this.resetValues();
      axios.get('/eid/kyc/status').then((response) => {
        const data = response.data;
        this.nationality = data.nationality || 'none';
        this.countries = data.countries || [];
        this.verified = data.verified || false;
        this.resettable = data.resettable || false;
        this.values = Object.assign(this.values, data.prefilled || {});
        this.loaded = true;
      });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
</style>
